import React from 'react'
import { isMobileOnly, isTablet } from 'react-device-detect'
import PropTypes from 'prop-types'

import { Dots, FlyingCube, Heading } from 'Components/Blocks/_Legacy'
import { Border, Icon, Link, Text, Wrapper } from 'Components/UI'
import { Button } from 'Components/UI/_Legacy'

import find from 'lodash/find'

import { programmingGlyph } from 'Assets/_Legacy/BlockchainPage/icons'
import arrowRightShortGlyph from 'Assets/_Legacy/Svg/arrow-right-short.svg'

import {
  DAPPS_DEVELOPMENT_GLYPHS,
  DAPPS_PROVIDE_CARDS_DATA,
} from 'Constants/Blockchain'
import { PROJECT, WORK } from 'Constants/Paths'

import { useAppContext } from 'Services/AppContext'

import {
  ButtonWrapper,
  Container,
  Content,
  CropContainer,
  DevelopmentCard,
  DevelopmentHolder,
  DevelopmentImageHolder,
  DevelopmentTextHolder,
  DotsWrapper,
  ProvideCard,
  ProvideHolder,
  ProvideIconHolder,
  ProvideSubHolder,
  ProvideSubRow,
  ProvideTextHolder,
} from './styles'

function Dapps({ data }) {
  const { openSupportWidget } = useAppContext()

  const projects = data?.projectsData?.projectsData || null

  return (
    <>
      <Border bg="primary" topRight />

      <Container>
        <FlyingCube
          left={[0, 0, 50, 50, 80, 140]}
          rotateAngle={39}
          size={[0, 0, 90, 90, 170]}
          top={[0, 0, -116, -116, -138]}
        />

        <CropContainer>
          <FlyingCube
            left={0}
            rotateAngle={39}
            size={[0, 0, 90, 90, 140, 180]}
            top={0}
          />
        </CropContainer>

        <Wrapper wayPointTop>
          <Content>
            <Heading
              horizontalAlign="center"
              maxWidth={700}
              mb={[56, 56, 64, 64, 88]}
              mx="auto"
              subTitleText={data?.dappsHeader?.subtitleText}
              tagGlyph={programmingGlyph}
              tagText={data?.dappsHeader?.overheadText}
              tagTextAs="h4"
              titleText={{
                first: {
                  text: data?.dappsHeader?.titleTextFirst,
                  bold: data?.dappsHeader?.firstBold,
                },
                second: {
                  text: data?.dappsHeader?.titleTextSecond,
                  bold: data?.dappsHeader?.secondBold,
                },
                third: {
                  text: data?.dappsHeader?.titleTextThird,
                  bold: data?.dappsHeader?.thirdBold,
                },
              }}
            />

            <DevelopmentHolder mb={[48, 48, 64, 64, 88]}>
              {data?.dappsDevelopmentBlocks.map((item, index) => {
                const even = index % 2
                return (
                  <DevelopmentCard
                    flexDirection={['column', 'column', 'row']}
                    key={item.id}
                  >
                    <DevelopmentTextHolder
                      order={[1, 1, even ? 1 : 0]}
                      pl={[0, 0, even ? 24 : 0, even ? 24 : 0, even ? 32 : 0]}
                      pr={[0, 0, even ? 0 : 24, even ? 0 : 24, even ? 0 : 32]}
                    >
                      <Text
                        as="h3"
                        bold
                        fontSize={[20, 20, 40]}
                        mb={[16, 16, 24]}
                      >
                        {item.title}
                      </Text>

                      <Text fontSize={[14, 14, 16]} semiLight>
                        {item.description}
                      </Text>
                    </DevelopmentTextHolder>

                    <DevelopmentImageHolder mb={[32, 32, 0]}>
                      <Icon
                        glyph={DAPPS_DEVELOPMENT_GLYPHS[index]}
                        size={['100%', '100%', '90%']}
                      />
                    </DevelopmentImageHolder>
                  </DevelopmentCard>
                )
              })}
            </DevelopmentHolder>

            <Heading
              fontSizes={{ title: [20, 20, 40], sub: [14, 16] }}
              horizontalAlign={isMobileOnly ? 'left' : 'center'}
              mb={[72, 72, 88, 88, 120]}
              mx="auto"
              subTitleText={data?.dappsHeaderSlave?.subtitleText}
              titleText={{
                first: {
                  text: data?.dappsHeaderSlave?.titleTextFirst,
                  bold: data?.dappsHeaderSlave?.firstBold,
                },
                second: {
                  text: data?.dappsHeaderSlave?.titleTextSecond,
                  bold: data?.dappsHeaderSlave?.secondBold,
                },
                third: {
                  text: data?.dappsHeaderSlave?.titleTextThird,
                  bold: data?.dappsHeaderSlave?.thirdBold,
                },
              }}
            />

            <ProvideHolder mb={[32, 32, 32, 32, 40]}>
              {data?.dappsProvideBlocks.map((item, index) => (
                <ProvideCard key={item.id}>
                  <ProvideIconHolder>
                    <Icon
                      glyph={DAPPS_PROVIDE_CARDS_DATA[index].glyph}
                      size={[36, 36, 46]}
                    />
                  </ProvideIconHolder>

                  <ProvideTextHolder mb={[24, 24, 20, 20, 32]}>
                    <Text
                      as="h3"
                      bold
                      fontSize={[16, 16, 20]}
                      mb={[8, 8, 8, 8, 16]}
                    >
                      {item.title}
                    </Text>

                    <Text fontSize={[14, 14, 14, 14, 16]} light>
                      {item.description}
                    </Text>
                  </ProvideTextHolder>

                  <ProvideSubHolder>
                    {DAPPS_PROVIDE_CARDS_DATA[index].sub.map(entity => {
                      const project = find(projects, ['id', entity.projectId])
                      return (
                        entity.projectId && (
                          <Link
                            href={project?.slug ? PROJECT(project.slug) : WORK}
                            key={entity.subText}
                            mr={[24, 24, 24, 16, 32]}
                          >
                            <ProvideSubRow>
                              <Icon
                                height={30}
                                mr={3}
                                src={entity.subImage}
                                width={30}
                              />

                              <Text fontSize={[16, 16, 16, 14, 16]} light>
                                {entity.subText}
                              </Text>
                            </ProvideSubRow>
                          </Link>
                        )
                      )
                    })}
                  </ProvideSubHolder>
                </ProvideCard>
              ))}

              <DotsWrapper>
                <Dots columns={isTablet ? 12 : 18} primary rows={18} />
              </DotsWrapper>
            </ProvideHolder>

            <ButtonWrapper>
              <Button blueprint width={250} onClick={openSupportWidget}>
                Discuss a project
                <Icon glyph={arrowRightShortGlyph} ml={12} size={10} />
              </Button>
            </ButtonWrapper>
          </Content>
        </Wrapper>
      </Container>
      <Border bg="almond" bottomLeft />
    </>
  )
}

Dapps.defaultProps = {
  data: {},
}

Dapps.propTypes = {
  data: PropTypes.object,
}

export default Dapps
